var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.651 22.35V2.81s-.04-.005-.079-.005C8.752 2.805 0 11.594 0 22.436 0 33.281 8.78 42 19.599 42c10.801 0 19.569-8.407 19.597-19.65H19.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 19.54s-.034.035-.034.017C41.967 8.752 33.673.062 22.456 0v19.54H42z"
  }))));
}
export default SvgPie;